// frontend/src/components/CampaignManager/tabs/WerbewegeTab.tsx
import React from 'react';
import {
  Box, Button, Stack, Typography, TableContainer, Table, TableHead, TableRow,
  TableCell, TableBody, Paper, IconButton, Chip, useMediaQuery, useTheme
} from '@mui/material';
import { Plus, PencilSimple, Trash } from '@phosphor-icons/react';
import { WerbewegCard } from '../MobileCards';
import { Werbeweg } from '../types';

interface Props {
  werbewege: Werbeweg[];
  deleteWerbeweg: (id: number) => Promise<void>;
  onOpenDialog: (werbeweg: Werbeweg | null) => void;
}

export default function WerbewegeTab({ werbewege, deleteWerbeweg, onOpenDialog }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDelete = async (id: number) => {
    if (window.confirm('Werbeweg wirklich löschen?')) {
      await deleteWerbeweg(id);
    }
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6">Werbewege</Typography>
        <Button
          variant="contained"
          size={isMobile ? 'small' : 'medium'}
          startIcon={<Plus size={20} />}
          onClick={() => onOpenDialog(null)}
          sx={{ backgroundColor: '#003366' }}
        >
          {isSmallMobile ? 'Neu' : 'Neuer Werbeweg'}
        </Button>
      </Stack>

      {isMobile ? (
        werbewege.length === 0 ? (
          <Paper variant="outlined" sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">Keine Werbewege vorhanden</Typography>
          </Paper>
        ) : (
          werbewege.map((werbeweg) => (
            <WerbewegCard key={werbeweg.id} werbeweg={werbeweg} onEdit={onOpenDialog} onDelete={handleDelete} />
          ))
        )
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Bezeichnung</TableCell>
                <TableCell>Kurzbezeichnung</TableCell>
                <TableCell>Bemerkungen</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Aktionen</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {werbewege.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                      Keine Werbewege vorhanden
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                werbewege.map((werbeweg) => (
                  <TableRow key={werbeweg.id} hover>
                    <TableCell><strong>{werbeweg.bezeichnung}</strong></TableCell>
                    <TableCell><Chip label={werbeweg.kurz} color="primary" size="small" /></TableCell>
                    <TableCell>{werbeweg.bemerkungen || '-'}</TableCell>
                    <TableCell>
                      <Chip label={werbeweg.active ? 'Aktiv' : 'Inaktiv'} color={werbeweg.active ? 'success' : 'default'} size="small" />
                    </TableCell>
                    <TableCell align="right">
                      <IconButton size="small" onClick={() => onOpenDialog(werbeweg)}>
                        <PencilSimple size={18} />
                      </IconButton>
                      <IconButton size="small" color="error" onClick={() => handleDelete(werbeweg.id)}>
                        <Trash size={18} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
